import { createSlice } from "@reduxjs/toolkit";

interface eventSubCategory {
  [key: string]: string[];
}

const INIT_STATE: any = {};

export const UpdateEventMetaSlice = createSlice({
  name: "UpdateEventMetaSlice",
  initialState: INIT_STATE,
  reducers: {
    addUpdatedEventData: (state, action) => {
      return {
        ...state,
        ...action.payload
      };
    }
  }
});
